export default __webpack_public_path__ + "resources/icons/n112-66c6.webp";